// src/lib/instanceAccess.js — pure; the hook wraps it. Mirrors server/src/auth/instance-access.ts.
export const INSTANCE_CAPABILITIES = ['impersonate', 'delete', 'manage_orgs', 'limits_billing', 'expiry', 'modules', 'resellers', 'imports'];

export function instanceAccessFrom(isSultan, instance) {
  const isAdmin = Boolean(isSultan) || instance?.role === 'admin';
  const isSupport = !isAdmin && instance?.role === 'support';
  const capabilities = isSupport ? (instance?.capabilities ?? []) : [];
  const can = (cap) => isAdmin || capabilities.includes(cap);
  return { isAdmin, isSupport, isStaff: isAdmin || isSupport, capabilities, can };
}
